import { FormControl, RadioGroup } from "@mui/material";
import { CustomRadioCroupProps } from "./types";
import CustomRadio from "./components/CustomRadio";
import { Controller } from "react-hook-form";
import ErrorMessage from "../ErrorMessage";
import { radioGroupStyles } from "./utils";

const CustomRadioGroup = ({
  options,
  control,
  name,
  idValidPay,
}: CustomRadioCroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { onChange, value, ...other } = field;

        return (
          <FormControl
            component="label"
            error={!!fieldState.error}
            sx={{ position: "relative", width: "100%" }}
          >
            <RadioGroup
              {...other}
              value={value}
              onChange={(_, value) => onChange(parseInt(value))}
              sx={radioGroupStyles}
            >
              {options?.map((opt) => (
                <CustomRadio
                  key={opt.id}
                  {...opt}
                  checked={value === opt.id}
                  idValidPay={idValidPay}
                />
              ))}
            </RadioGroup>
            {fieldState.error?.message && (
              <ErrorMessage
                message={
                  idValidPay
                    ? "Payment method is required."
                    : fieldState.error.message
                }
              />
            )}
          </FormControl>
        );
      }}
    />
  );
};

export default CustomRadioGroup;
